/**
 * Numeric constants for the rules engine.
 * Single source of truth — imported by updateOrdersDropDowns, ReRunRulesModal, etc.
 */

/** Maximum orders that can be sent in a single manual re-run request. */
export const MAX_ORDERS_PER_REQUEST = 200;

/** Orders above this threshold skip the dry-run preview. */
export const DRY_RUN_THRESHOLD = 100;

/** Maximum number of polling attempts (at POLL_INTERVAL_MS each). */
export const MAX_POLL_ATTEMPTS = 60;

/** Milliseconds between polling attempts. */
export const POLL_INTERVAL_MS = 2000;
